import React, { useState } from 'react'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import isNull from 'lodash/isNull'
import { connect } from 'react-redux'

import { RawExpando } from 'discada/dist/Expando'
import Button from 'discada/dist/Button'
import { TextField } from 'discada/dist/Form'

import { replaceFilter } from 'actions/inventoryActions'
import { getSelectedFilterValue } from 'selectors/inventorySelectors'

import Modal, { ModalBody, ModalControls } from 'discada/dist/Modal'
import { addToPageState, removeFromPageState } from 'actions/pageStateActions'
import { getQueryValue } from 'selectors/pageStateSelectors'
import {
  getQuoteDefaultValue,
  getQuoteDefaultValues,
} from 'selectors/appStatusSelectors'

import { WILDCARD } from 'selectors/quoteSelectors'

import './DropDownFilter.scss'

const CUSTOMIZE_PARAM = 'customizeFilter'
const CUSTOM_VALUE_KEY = 'custom'

const getFormLabel = key => {
  let specs = {
      zipCode: "What's your Zip Code?",
      leaseTerm: 'How many months do you want to lease?',
      loanTerm: 'How many months do you want to finance?',
      payment: 'What do you want your monthly payment to be?',
      down: 'What do you want your down payment to be?',
    },
    fallback = `What do you want your ${key} to be?`

  return get(specs, key, fallback)
}

export const CustomizeFilterModalPreso = props => {
  let {
      filter,
      removeFromPageState,
      replaceFilter,
      namespace,
      customize = {},
    } = props,
    { fieldType } = customize,
    close = () => removeFromPageState(CUSTOMIZE_PARAM)

  const [value, setValue] = useState(),
    submit = () => {
      replaceFilter({ filter, value }, namespace)
      close()
    },
    proc = v => (fieldType === 'number' ? parseInt(v, 10) : v) // TODO do we need to convert this

  return (
    <Modal noClose className="auto-width custom-filter-modal">
      <ModalBody>
        <TextField
          value={value}
          type={fieldType}
          label={getFormLabel(filter)}
          onChange={({ target }) => setValue(proc(target.value))}
          onKeyPress={e => e.key === 'Enter' && submit()}
        />
      </ModalBody>
      <ModalControls>
        <Button success size="small" onClick={submit}>
          Apply
        </Button>
        <Button text size="small" onClick={close}>
          Close
        </Button>
      </ModalControls>
    </Modal>
  )
}

export const CustomizeFilterModal = connect(
  (_, op) => op,
  { replaceFilter, removeFromPageState },
)(CustomizeFilterModalPreso)

//////////////////////

export function DropDownFilter(props) {
  let {
      filter,
      value,
      defaultValue,
      options = [],
      replaceFilter,
      customize = {},
      customInputActive,
      addToPageState,
      allowWilcard,
      icon = 'chevron-down',
      label = v => v,
      namespace,
      prefix,
    } = props,
    noOptions = isEmpty(options),
    allowCustom = !isEmpty(customize),
    onClick = value => {
      if (isEmpty(options) || value === CUSTOM_VALUE_KEY) {
        addToPageState({ [CUSTOMIZE_PARAM]: filter })
      } else if (value === WILDCARD) {
        replaceFilter({ filter, value: WILDCARD }, namespace)
      } else {
        replaceFilter({ filter, value }, namespace)
      }
    }

  // if customiable, add option to open the customize modal
  if (allowCustom) options = [...options, CUSTOM_VALUE_KEY]
  // add option to reset dropdown filter value at the end
  if (allowWilcard) options = [...options, null, WILDCARD]

  const dropDownLabel = option => {
    if (option === WILDCARD) return label()
    else if (option === CUSTOM_VALUE_KEY) return 'Customize...'

    return label(option)
  }

  return (
    <>
      <RawExpando>
        {({ toggle, open }) => {
          return (
            <div
              className={c('dropdown-filter dropdown', { 'is-active': open })}
            >
              <div
                className={c('dropdown-filter-background', {
                  'is-active': open,
                })}
                onClick={toggle}
              />
              <Button
                reverse
                className={c('filter-button', 'dropdown-trigger', {
                  'story-filter-has-value':
                    !isNull(value) &&
                    typeof value !== 'undefined' &&
                    value !== WILDCARD,
                  'story-filter-large': props.size === 'large',
                })}
                aria-haspopup="true"
                icon={icon}
                size={props.size}
                onClick={() =>
                  noOptions
                    ? addToPageState({ [CUSTOMIZE_PARAM]: filter })
                    : toggle()
                }
              >
                {prefix && <small>{prefix}</small>}
                <strong>{dropDownLabel(value || defaultValue)}</strong>
              </Button>
              <div className="dropdown-menu" role="menu">
                <div className="dropdown-content">
                  {options.map((option, i) => {
                    return !isEmpty(option) ? (
                      <a // eslint-disable-line
                        key={i}
                        className={c('dropdown-item')}
                        onClick={() => {
                          onClick(option)
                          toggle()
                        }}
                      >
                        {dropDownLabel(option)}
                      </a>
                    ) : (
                      <hr key={i} />
                    )
                  })}
                </div>
              </div>
            </div>
          )
        }}
      </RawExpando>

      {customInputActive && <CustomizeFilterModal {...props} />}
    </>
  )
}

function mapStateToProps(state, op) {
  // TODO need to tell the differnce between no value set and 'any value'
  let defaultValue =
      op.defaultValue || getQuoteDefaultValue(state, op.configKey),
    value = getSelectedFilterValue(state, op.filter, op.value),
    valid = typeof value !== 'undefined' && !isNull(value)

  return {
    ...op,
    value: valid ? value : defaultValue,
    defaultValue,
    customInputActive: getQueryValue(state, CUSTOMIZE_PARAM) === op.filter,
    options: op.configKey
      ? getQuoteDefaultValues(state, op.configKey)
      : op.options || [],
  }
}

export default connect(
  mapStateToProps,
  { replaceFilter, addToPageState, removeFromPageState },
)(DropDownFilter)
